export const Loader = () => {
  return <p className={'loader'}>Loading...</p>;
};
